import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { useIcsFormPdfPreview } from 'components/IAP/context/IcsFormPdfPreviewContext';
import { FormExportButton } from 'components/IAP/FormExportButton';

const ICSFormsExport: React.FC = () => {
  const { exportAsForm } = useIcsFormPdfPreview();

  const handleExportForm = (formname: string, format: 'pdf' | 'docx' = 'pdf') => {
    void exportAsForm({ formname, data: {}, mapSketch: null, format });
  };

  return (
    <>
      <div className="planning-widget p-3">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="mt-0">
            <SharedIcon iconName="download" classes="me-2" />
            ICS Form Export
          </h3>
        </div>
        <div className="text-weak">
          Export completed ICS forms for the planning meeting
        </div>
        <div className="d-flex justify-content-center gap-2 flex-wrap mt-3">
          <FormExportButton
            formname="ICS_215_CG"
            onExport={(format) => handleExportForm('ICS_215_CG', format)}
            label="Preview ICS-215"
          />
          <FormExportButton
            formname="ICS_215A_CG"
            onExport={(format) => handleExportForm('ICS_215A_CG', format)}
            label="Preview ICS-215A"
          />
          <FormExportButton
            formname="ICS_213RR_CG"
            onExport={(format) => handleExportForm('ICS_213RR_CG', format)}
            label="Preview ICS-213RR"
          />
        </div>
      </div>
    </>
  );
};

export default ICSFormsExport;
